"use strict";

module.exports = require('./lib/Inflector');